import api, { fetchCsrfCookie, unwrap } from './client'
import type { AcceptInvitePayload, Invite, InvitePayload, User } from '@/types/models'

export const invitesApi = {
  async index(): Promise<Invite[]> {
    return (await unwrap(api.get<{ data: Invite[] }>('/invites'))) ?? []
  },

  store(payload: InvitePayload): Promise<Invite> {
    return unwrap(api.post<{ data: Invite }>('/invites', payload))
  },

  resend(id: string): Promise<Invite> {
    return unwrap(api.post<{ data: Invite }>(`/invites/${id}/resend`))
  },

  revoke(id: string): Promise<unknown> {
    return api.delete(`/invites/${id}`)
  },

  show(token: string): Promise<Invite> {
    return unwrap(api.get<{ data: Invite }>(`/auth/invites/${token}`))
  },

  async accept(payload: AcceptInvitePayload): Promise<User> {
    await fetchCsrfCookie()
    return unwrap(api.post<{ data: User }>('/auth/accept-invite', payload))
  },
}
